export var HourBand;
(function (HourBand) {
    HourBand["Morning"] = "Morning";
    HourBand["Afternoon"] = "Afternoon";
    HourBand["Evening"] = "Evening";
})(HourBand || (HourBand = {}));
/**
 * Groups items by day.
 * Returns a record where keys are ISO date strings (YYYY-MM-DD).
 */
export const groupByDay = (items) => {
    return items.reduce((acc, item) => {
        const dateKey = item.time.toISODate();
        if (!dateKey)
            return acc;
        if (!acc[dateKey]) {
            acc[dateKey] = [];
        }
        acc[dateKey].push(item);
        return acc;
    }, {});
};
/**
 * Groups items by hour band:
 * - Morning: before 12:00
 * - Afternoon: 12:00 - 17:00
 * - Evening: after 17:00
 */
export const groupByHourBand = (items) => {
    const initial = {
        [HourBand.Morning]: [],
        [HourBand.Afternoon]: [],
        [HourBand.Evening]: [],
    };
    return items.reduce((acc, item) => {
        const hour = item.time.hour;
        let band;
        if (hour < 12) {
            band = HourBand.Morning;
        }
        else if (hour < 17) {
            band = HourBand.Afternoon;
        }
        else {
            band = HourBand.Evening;
        }
        acc[band].push(item);
        return acc;
    }, initial);
};
export var EngagementState;
(function (EngagementState) {
    EngagementState["NotSeen"] = "not-seen";
    EngagementState["Seen"] = "seen";
    EngagementState["Complete"] = "complete";
})(EngagementState || (EngagementState = {}));
/**
 * Derives engagement state from item properties.
 * Logic based on design spec:
 * - Complete: kind is 'mark-complete' or similar (needs refinement based on actual data)
 * - Seen: has a 'view-alert' event
 * - NotSeen: default
 */
export const deriveItemEngagement = (item) => {
    if (item.status === 'done' || item.events?.some(e => e.eventType === 'mark-complete')) {
        return EngagementState.Complete;
    }
    if (item.events?.some(e => e.eventType === 'view-alert')) {
        return EngagementState.Seen;
    }
    return EngagementState.NotSeen;
};
